import axios from 'axios';

import { getPath } from '../common/api';
import type { SiteId, HighlightId } from '../common/api';
import type { PaginatedResponse as PaginatedResponseModel } from '../common/model';
import type { PaginatedResponse as PaginatedResponseDto } from '../common/dto';
import type {
  RecordingHighlight as RecordingHighlightDto,
  RecordingOnlyHighlightsListItem as RecordingOnlyHighlightsListItemDto,
} from './dto';
import type {
  RecordingHighlight as RecordingHighlightModel,
  RecordingHighlightCreateData as RecordingHighlightCreateDataModel,
  RecordingOnlyHighlightsListItem as RecordingOnlyHighlightsListItemModel,
  RecordingHighlightStatus as RecordingHighlightStatusModel,
} from './model';
import {
  mapRecordingOnlyHighlightsDtoToModel,
  mapHighlightDtoToRecordingHighlightModel,
  mapRecordingHighlightCreateDataModelToDto,
  mapRecordingHighlightStatusDtoToModel,
} from './mapper';

export async function getRecordingHighlights(
  siteId: SiteId,
  recordingId: number,
): Promise<PaginatedResponseModel<RecordingOnlyHighlightsListItemModel>> {
  const response = await axios.get<PaginatedResponseDto<RecordingOnlyHighlightsListItemDto>>(
    `${getPath(siteId)}/recording`,
    {
      params: { recording_id: recordingId },
    },
  );

  return mapRecordingOnlyHighlightsDtoToModel(response.data);
}

export async function createRecordingHighlight(
  siteId: SiteId,
  payload: RecordingHighlightCreateDataModel,
): Promise<RecordingHighlightModel> {
  const data = mapRecordingHighlightCreateDataModelToDto(payload);

  const response = await axios.post<RecordingHighlightDto>(`${getPath(siteId)}/recording`, data);

  return mapHighlightDtoToRecordingHighlightModel(response.data);
}

export async function getStatus(
  siteId: SiteId,
  highlightId: HighlightId,
): Promise<RecordingHighlightStatusModel> {
  const path = `${getPath(siteId)}/recording/${highlightId}/status`;

  const response = await axios.get(path);

  return mapRecordingHighlightStatusDtoToModel(response.data);
}
